import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSiteProductKind } from '../../constants/siteConfig';
import { productPathRedirect } from '../../utils/productRoutes';

/**
 * Keeps each site on its own screens (spec 016): car routes on the stays site
 * and stay routes on a car site redirect home. It wraps the routes and renders
 * only the redirect when one is due, so the foreign page never mounts (a car
 * page that rewrites its own URL on mount would otherwise undo the redirect).
 */
export function ProductPathGuard({ children }: { children?: ReactNode }) {
  const { pathname } = useLocation();
  const target = productPathRedirect(pathname, getSiteProductKind());
  return target ? <Navigate to={target} replace /> : <>{children}</>;
}
